import Marquee from "react-fast-marquee";
import { useReducedMotion } from "framer-motion";

const trades = [
  "Electricians",
  "Plumbers",
  "Solar & Battery",
  "Heating & Cooling",
  "Builders",
  "Landscapers",
  "Roofers",
  "Painters",
  "Cleaning",
  "Pest Control",
];

const MarqueeItem = ({ label }) => (
  <span className="mx-8 inline-flex items-center gap-8">
    <span className="text-3xl md:text-5xl font-extrabold tracking-tight text-white/90">
      {label}
    </span>
    <span className="h-2.5 w-2.5 rounded-full bg-lime" aria-hidden="true" />
  </span>
);

// Slow editorial marquee of the trades served. Deep Forest bg, mint outlined.
export default function TradesMarquee() {
  const reduce = useReducedMotion();

  return (
    <section
      data-testid="trades-marquee"
      className="bg-forest py-10 md:py-14 border-y border-white/10"
      aria-label="Trades we serve"
    >
      {reduce ? (
        <div className="flex flex-wrap justify-center gap-x-8 gap-y-3 px-6">
          {trades.map((t) => (
            <span
              key={t}
              className="text-xl font-extrabold text-white/90"
            >
              {t}
            </span>
          ))}
        </div>
      ) : (
        <Marquee speed={40} gradient={false} autoFill>
          {trades.map((t) => (
            <MarqueeItem key={t} label={t} />
          ))}
        </Marquee>
      )}
    </section>
  );
}
